import * as React from "react";
import classnames from "classnames";
import { Step, StepName } from "./step";
import t from "../i18n";
import { wfStyles } from "../_styles/workflow";
import { css } from "emotion";

declare type WorkflowProps = {
    step: Step;
    onStepChanged: (step: StepName) => void;
}
declare type WorkflowState = {
    visited1: "current" | "visited" | "notVisited";
    visited2: "current" | "visited" | "notVisited";
    visited3: "current" | "visited" | "notVisited";
    visited4: "current" | "visited" | "notVisited";
    visited5: "current" | "visited" | "notVisited";
}
export default class Workflow extends React.Component<WorkflowProps, WorkflowState> {
    readonly state: WorkflowState = {
        visited1: "current",
        visited2: "notVisited",
        visited3: "notVisited",
        visited4: "notVisited",
        visited5: "notVisited"
    }
    onStepChanged = (newStep: StepName) => {
        if (this.props.step.compareTo(newStep) !== ">") return;
        if (this.props.onStepChanged) this.props.onStepChanged(newStep);
    }
    render() {
        switch(this.props.step.stepCount)
        {
            case 5: return this.render5(); break;
            case 3: return this.render3(); break;
            default: return this.render4(); break;
        }
    }
    render4() {
        const sn = this.props.step;
        const visited1 = sn.compareTo("number") === "=" ? "current" : "visited";
        const visited2 = sn.compareTo("order") === "<" ? "notVisited" : sn.compareTo("order") === "=" ? "current" : "visited";
        const visited3 = sn.compareTo("summary") === "<" ? "notVisited" : sn.compareTo("summary") === "=" ? "current" : "visited";
        const visited4 = sn.compareTo("payment") === "<" ? "notVisited" : sn.compareTo("payment") === "=" ? "current" : "visited";
        return (
            <div style={{ position: "relative" }}>
                <div className="bubble-line" />
                <div className="worflow">
                    <div className="workflow-stop" onClick={e => this.onStepChanged("number")}>
                        <div className={classnames("bubble", css(wfStyles[visited1]))}>1</div>
                        <div>{t.menu("number")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("order")}>
                        <div className={classnames("bubble", css(wfStyles[visited2]))}>2</div>
                        <div>{t.menu("order")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("summary")}>
                        <div className={classnames("bubble", css(wfStyles[visited3]))}>3</div>
                        <div>{t.menu("summary")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("payment")}>
                        <div className={classnames("bubble", css(wfStyles[visited4]))}>4</div>
                        <div>{t.menu("payment")}</div>
                    </div>
                </div>
            </div>
        );
    }
    render5() {
        const sn = this.props.step;
        const visited1 = sn.compareTo("number") === "=" ? "current" : "visited";
        const visited2 = sn.compareTo("operator") === "<" ? "notVisited" : sn.compareTo("operator") === "=" ? "current" : "visited";
        const visited3 = sn.compareTo("order") === "<" ? "notVisited" : sn.compareTo("order") === "=" ? "current" : "visited";
        const visited4 = sn.compareTo("summary") === "<" ? "notVisited" : sn.compareTo("summary") === "=" ? "current" : "visited";
        const visited5 = sn.compareTo("payment") === "<" ? "notVisited" : sn.compareTo("payment") === "=" ? "current" : "visited";
        return (
            <div style={{ position: "relative" }}>
                <div className="bubble-line" />
                <div className="worflow">
                    <div className="workflow-stop" onClick={e => this.onStepChanged("number")}>
                        <div className={classnames("bubble", css(wfStyles[visited1]))}>1</div>
                        <div>{t.menu("number")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("operator")}>
                        <div className={classnames("bubble", css(wfStyles[visited2]))}>2</div>
                        <div>{t.menu("operator")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("order")}>
                        <div className={classnames("bubble", css(wfStyles[visited3]))}>3</div>
                        <div>{t.menu("order")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("summary")}>
                        <div className={classnames("bubble", css(wfStyles[visited4]))}>4</div>
                        <div>{t.menu("summary")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("payment")}>
                        <div className={classnames("bubble", css(wfStyles[visited5]))}>5</div>
                        <div>{t.menu("payment")}</div>
                    </div>
                </div>
            </div>
        );
    }
    render3() {
        const sn = this.props.step;
        const visited1 = sn.compareTo("order") === "=" ? "current" : "visited";
        const visited2 = sn.compareTo("summary") === "<" ? "notVisited" : sn.compareTo("summary") === "=" ? "current" : "visited";
        const visited3 = sn.compareTo("payment") === "<" ? "notVisited" : sn.compareTo("payment") === "=" ? "current" : "visited";
        return (
            <div style={{ position: "relative" }}>
                <div className="bubble-line" />
                <div className="worflow">
                    <div className="workflow-stop" onClick={e => this.onStepChanged("order")}>
                        <div className={classnames("bubble", css(wfStyles[visited1]))}>1</div>
                        <div>{t.menu("order")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("summary")}>
                        <div className={classnames("bubble", css(wfStyles[visited2]))}>2</div>
                        <div>{t.menu("summary")}</div>
                    </div>
                    <div className="workflow-stop" onClick={e => this.onStepChanged("payment")}>
                        <div className={classnames("bubble", css(wfStyles[visited3]))}>3</div>
                        <div>{t.menu("payment")}</div>
                    </div>
                </div>
            </div>
        );
    }
}